import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["summaryTxtEl", "copyBtn", "statusEl", "summaryToggleBtn"];

  // Copies the full generated summary to the clipboard.
  // Called by the summary card's Copy button on click->document-summary#copy.
  // Announces success or failure to screen-reader users through the status target.
  async copy() {
    try {
      await navigator.clipboard.writeText(this.summaryTxtElTarget.textContent.trim());
      const iconEl = this.copyBtnTarget.querySelector("i");
      iconEl.classList.replace("bi-copy", "bi-check2");
      this.copyBtnTarget.setAttribute("aria-label", "Summary copied");
      this.statusElTarget.textContent = "Summary copied to clipboard.";

      window.setTimeout(() => {
        if (!this.element.isConnected) return;

        iconEl.classList.replace("bi-check2", "bi-copy");
        this.copyBtnTarget.setAttribute("aria-label", "Copy AI document summary");
      }, 1600);
    } catch {
      this.statusElTarget.textContent = "Clipboard access failed. Select the summary text to copy it.";
    }
  }

  // Expands or collapses the clamped summary paragraph in place.
  // Called by the summary disclosure button on click->document-summary#toggleSummary.
  // Updates aria-expanded so assistive technology receives the disclosure state.
  toggleSummary() {
    const isExpanded = this.summaryToggleBtnTarget.getAttribute("aria-expanded") === "true";
    this.summaryToggleBtnTarget.setAttribute("aria-expanded", String(!isExpanded));
    this.summaryTxtElTarget.classList.toggle("is-expanded", !isExpanded);
  }
}
